import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
  <footer className="bg-dark text-white py-16 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Grille principale */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">

          {/* Colonne 1 - Logo & description */}
          <div className="md:col-span-2">
            <div className="text-2xl font-bold mb-4">
              <span className="text-accent">EFE</span>-SYSTEMS
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Nous transformons vos idées en solutions numériques 
              performantes. Spécialistes en développement web, 
              mobile et bases de données.
            </p>
            {/* Réseaux sociaux */}
            <div className="flex gap-3 mt-6">
              <a href="#" className="bg-white/10 hover:bg-accent w-9 h-9 rounded-full flex items-center justify-center transition">
                in
              </a>
              <a href="#" className="bg-white/10 hover:bg-accent w-9 h-9 rounded-full flex items-center justify-center transition">
                gh
              </a>
              <a href="#" className="bg-white/10 hover:bg-accent w-9 h-9 rounded-full flex items-center justify-center transition">
                tw
              </a>
            </div>
          </div>

          {/* Colonne 2 - Services */}
          <div>
            <h4 className="font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#services" className="hover:text-accent transition">Bases de Données</a></li>
              <li><a href="#services" className="hover:text-accent transition">Sites Internet</a></li>
              <li><a href="#services" className="hover:text-accent transition">Web Apps</a></li>
              <li><a href="#services" className="hover:text-accent transition">Application Android</a></li>
              <li><a href="#services" className="hover:text-accent transition">Application iOS</a></li>
            </ul>
          </div>

          {/* Colonne 3 - Liens rapides */}
          <div>
            <h4 className="font-bold text-white mb-4">Liens rapides</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#equipe" className="hover:text-accent transition">Notre Équipe</a></li>
              <li><a href="#portfolio" className="hover:text-accent transition">Portfolio</a></li>
              <li><Link to="/login" className="hover:text-accent transition">Espace Client</Link></li>
              <li><Link to="/register" className="hover:text-accent transition">Demander un devis</Link></li>
            </ul>
          </div>

        </div>

        {/* Séparateur */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} EFE-SYSTEMS. Tous droits réservés.
          </p>
          <p className="text-gray-500 text-sm">
            Conçu avec ❤️ par <span className="text-accent">EFE-SYSTEMS</span>
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;